import * as Yup from 'yup';
import React, { useState, useEffect } from "react"
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './changePassword.css'
import Iconify from '../Iconify';
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { LoadingButton } from '@mui/lab';
import { Button, Stack, IconButton, InputAdornment, Box } from '@mui/material';
import { Link, useNavigate } from "react-router-dom"
import { login } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
import { changePassword } from '../../api/password';
// -------------------------------------------------

const ChangePassword = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [showError, setShowError] = useState();
  const [showLoader, setShowLoader] = useState();
  const notify = (message) => toast(message)
  const LoginSchema = Yup.object().shape({
    newPassword: Yup.string().required('Password is Required'),
    confirmPassword: Yup.string().required('Confirm Password is required'),
  });

  const defaultValues = {
    hnewPassword: '',
    confirmPassword: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      delete data.confirmPassword
      const resp = await changePassword(data)
      if (resp.code === 202) {
        notify(resp.message)
        navigate('/')
      }
    } catch (error) {
      notify(error.message)
    }
    setShowLoader(false)
  };

  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-9'>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 5px rgba(16, 16, 16, .09)',
                  p: 2,
                  borderRadius: '25px',
                }}
              >
                <div className='row'>
                  <div className='col-md-6'>
                    <img src='../images/signin.svg' />
                  </div>
                  <div className='col-md-6'>
                    <div className='accountSection'>
                      <img src='../images/logo.jpg' />
                      <h3>Change Password</h3>
                      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Stack sx={{ py: 2 }}>
                          <RHFTextField
                            name="newPassword"
                            label="New Password"
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack sx={{ py: 2 }}>
                          <RHFTextField
                            size="small"
                            name="confirmPassword"
                            label="Confirm Password"
                            type={confirmPassword ? 'text' : 'password'}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton onClick={() => setConfirmPassword(!confirmPassword)} edge="end">
                                    <Iconify icon={confirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          ></RHFTextField>
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <LoadingButton fullWidth size="large" type="submit" className='signBtn' loading={isSubmitting}>
                            Submit
                          </LoadingButton>
                        </Stack>
                      </FormProvider>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
      <Footer />
    </>
  )
}

export default ChangePassword
